import fetch from '@/utils/fetch';
import * as API from '@/commons/http-api';
import { Toast } from 'antd-mobile';
/**
 * 示例模块
 */
export default {
  namespace: 'meetingData',
  state: {
    personRankingArray: [], // 排行榜 个人直营榜
    groupRankingArray: [], // 排行榜 T队汇总榜
    productNumber: 0, // 机具数量
    personOutputArray: [], // 会议产出 个人直营榜
    groupOutputArray: [], // 会议产出 T队直营榜
    meetingResult: [], // 会议结果
  },
  reducers: {
    setPersonRankingArray(state, action) {
      return {
        ...state,
        personRankingArray: action.payload,
      };
    },
    setGroupRankingArray(state, action) {
      return {
        ...state,
        groupRankingArray: action.payload,
      };
    },
    setProductNumber(state, action) {
      return {
        ...state,
        productNumber: action.payload,
      };
    },
    setPersonnOutputArray(state, action) {
      return {
        ...state,
        personOutputArray: action.payload,
      };
    },
    setGroupnOutputArray(state, action) {
      return {
        ...state,
        groupOutputArray: action.payload,
      };
    },
    setMeetingResult(state, action) {
      return {
        ...state,
        meetingResult: action.payload,
      };
    },
  },
  effects: {
    /** 会议数据 排行榜 */
    *requestMeetingRankingAction(action, { put }) {
      const { params, callback = () => {} } = action.payload;

      const res = yield fetch.post(API.getMeetingRankListUrl, JSON.stringify(params));
      if (res.errorType && res.errorType === 'ERROR') {
        return Toast.fail(res.message);
      } else {
        const { data = [] } = res;
        if (callback && typeof callback === 'function') {
          callback(data);
        }
        // rankType:  // 0个人 1T队
        const { rankType = '' } = params;
        if (rankType === '0') {
          yield put({
            type: 'setPersonRankingArray',
            payload: data,
          });
        } else {
          yield put({
            type: 'setGroupRankingArray',
            payload: data,
          });
        }
      }
    },

    /** 会议数据 会议产出 */
    *requestMeetingOutputAction(action, { put }) {
      const { params, callback = () => {} } = action.payload;

      const res = yield fetch.post(API.getMeetingProdRatioTabUrl, JSON.stringify(params));
      if (res.errorType && res.errorType === 'ERROR') {
        return Toast.fail(res.message);
      } else {
        const { data = {} } = res;
        const { list = [], prodCount = 0 } = data;
        if (callback && typeof callback === 'function') {
          callback(data);
        }
        // prodType:  // 0个人 1T队
        const { prodType = '' } = params;
        if (prodType === '0') {
          yield put({
            type: 'setProductNumber',
            payload: prodCount,
          });
          yield put({
            type: 'setPersonnOutputArray',
            payload: list,
          });
        } else {
          yield put({
            type: 'setGroupnOutputArray',
            payload: list,
          });
        }
      }
    },
    /** 会议数据 会后效果 */
    *requestMeetingResultAction(action, { put }) {
      const { params, callback = () => {} } = action.payload;
      const res = yield fetch.post(API.getMeetingIncRatioUrl, JSON.stringify(params));
      if (res.errorType && res.errorType === 'ERROR') {
        return Toast.fail(res.message);
      } else {
        const { data = [] } = res;
        if (callback && typeof callback === 'function') {
          callback(data);
        }
        yield put({
          type: 'setMeetingResult',
          payload: data,
        });
      }
    },
  },
};
